import { Component, OnInit , ViewChild} from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AdminImageCroperComponent } from '../../shared/components/popupAdmin/popup-imagecropper.component';
import {AlyleUIModule,LyResizingCroppingImageModule,} from '../../../alyle-ui';


@Component({
    selector: 'create-segment',
    templateUrl: './Createsegments.component.html',
    // styleUrls: ['./dashboard.component.scss']
     providers: [ SharedService,AdminImageCroperComponent],

})
export class CreateSegmentsComponent implements OnInit {

data = [];
imageDta: any;
  imageData: any=[];
  croppedWidth: number;
  croppedHeight: number;
    data1: any;
    segmentUpdCrtForm:FormGroup;
    segmentImage="";
    loaderFlag : boolean;
    objLoaderStatus: boolean = false;
    imgId :number =0;
    successUplaodImg ='';
     name = "";
    description ="";
    imgUrl = "";
    id : number;
    blob:any;
imageFlagUplaod = false;
    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,private router: Router,
    private dialogService:DialogService,
    private imgComp : AdminImageCroperComponent) {

   console.log(imgComp.imgId) ;
    }

    ngOnInit() {
var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
this.localstorage.setStorage("country",'');

this.segmentUpdCrtForm = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      
    });

    }

   
  b64toBlobNew(b64Data,contentType){
      var byteCharacters = atob(b64Data);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);
      var blob = new Blob([byteArray], {type: contentType});
      return blob;
  }


  uploadImage() {
    this.loaderFlag=true;
    let fileList: FileList = this.imageData;
     console.log(fileList);
     let file: File = fileList[0];
     let formData:FormData = new FormData();
     // formData.append('banner', file, file.name);
    var token = this.localstorage.getStorage("token");
    formData.append('profilePic', this.blob);

                 this.loaderService.displayLoader(true);
    // var bannerImage={"banner":this.data1.image};
    this.shareService.uploadImage("admin/uploadSegmentImage", formData, token).subscribe((result) => {
    if (result.data) {
        console.log(result.data);
        if(result.data.id !== null){
            this.imgId = result.data.id;
           // this.segmentUpdCrtForm.valid= true;
            this.successUplaodImg="Image successfully uploaded.";
          } else {
              this.imgId =0;
            this.successUplaodImg="";
          }
          setTimeout(() => {
              this.successUplaodImg="";
              this.loaderFlag=false;
          }, 3000);
          
      } else {
          this.loaderFlag=false;
      }
      this.loaderService.displayLoader(false);
    });
  }
  
urltoFile(url, filename, mimeType){
    return (fetch(url)
        .then(function(res){return res.arrayBuffer();})
        .then(function(buf){return new File([buf], filename, {type:mimeType});})
    );
}

  showImageBox() {
        let disposable = this.dialogService.addDialog(AdminImageCroperComponent, {
            title: 'Draft Campaign',
            message: 'Campaign Saved Successfully.'
         })
            .subscribe((result) => {
                console.log(result);
                //We get dialog result
                if (result.isConfirmed && result.imgId !== undefined) {
                    this.imgId = result.imgId;
                                      this.imageFlagUplaod = false;

                }
                else if(result.isConfirmed == false && result.imgId !== undefined){
                    this.imgId = result.imgId;
                  this.imageFlagUplaod = true;
                }
                else{
                    this.imgId = 0;
                      this.imageFlagUplaod = false;
                }
            }); 
        //We can close dialog calling disposable.unsubscribe();
        //If dialog was not closed manually close it by timeout
    }

  checkimageURL(url) {
      if(url) {
          return(url.match(/\.(jpeg|jpg|gif|png)$/) != null);
      }
      
    }

fileChangeListener($event) {
    
    this.imageDta = $event.target.files;
    console.log(this.imageDta);
    var image: any = new Image();
    var file: File = $event.target.files[0];
    var myReader: FileReader = new FileReader();
    var that = this;
    document.getElementsByTagName("canvas")[0].style.display = "block";
    myReader.onloadend =  (loadEvent:any)=> {
       // image.src = loadEvent.target.result;
        var imageDta=loadEvent.target.result;
        let type=imageDta.split(';')[0].split(':')[1];
        console.log(type);
        console.log(type.split("/")[1]);
        var extention=type.split("/")[1];
        //let type = this.imageDta.split(';')[0].split(':')[1];
        //let extension=type.splif("/")[1];
        this.urltoFile(imageDta,'croped.'+extention,type).then((result) => {
            this.imageDta[0]=result;
            
    });
        
      //  that.cropper.setImage(image);
    };
   var t= myReader.readAsDataURL(file);
   console.log(t);
  }

createData(){
     var token = this.localstorage.getStorage("token");
     var data : any ={};
   
     data.imageId = this.imgId;
    
     data.name = this.name;
     data.description = this.description;
     console.log(this.imgId);
     console.log(data);
                   this.loaderService.displayLoader(true);

       this.shareService.callApiWithToken("admin/createSegment", data, token).subscribe((result) => {
    console.log(result.data);
   if(result.data){
   
     this.router.navigate(['admin/segments']);
   }
   else{
       alert(result.meta.message);
   }
                 this.loaderService.displayLoader(false);

         });
}

}



// WEBPACK FOOTER //
// ./src/app/admin/layout/updateCreateSegments/Createsegments.component.ts